import { useAtom } from 'jotai';
import { basdataTabAtom } from './atoms.ts';

// Hook för att hämta/sätta vilken basdata-pill som är selectad.
export const useBasdataTab = (): [string | undefined, (value: string) => void] => {
    return useAtom(basdataTabAtom);
};
